module.exports = __webpack_public_path__ + "static/img/3.79df87f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/3.png
// module id = XncC
// module chunks = 0